import React, { Component } from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import BackButton from '../COMPONENTS/BackButton';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import { HIDDEN, SHOW, FADE, HIDE } from '../../HOME/const';
import * as f from '../logic';
import { delay } from '../../HOME/utils';
import { Background } from '../COMPONENTS/Background';
import Toolbar from '../COMPONENTS/Toolbar';
import Scoreboard from '../COMPONENTS/Scoreboard';
import Board from '../COMPONENTS/Board';
import Options from '../COMPONENTS/Options';
import Leaderboard from '../COMPONENTS/Leaderboard';
import { updateStats, showHelp } from '../REDUX/actions';
import { requestResetStats, requestSurrender } from '../../HOME/REDUX/actions';

class GamePage extends Component {
  state = { options: HIDDEN };
  board = React.createRef();
  toolbar = React.createRef();
  scoreboard = React.createRef();

  onResize = () => {
    this.forceUpdate();
  };

  componentDidMount() {
    window.addEventListener('resize', this.onResize);

    f.getStats(this.props, stats => {
      this.props.updateStats(stats);
    });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  handleOptions = e => {
    this.props.requestResetStats(false);
    this.props.requestSurrender(false);
    this.props.showHelp(false);

    const op = this.state.options;

    if (op === SHOW) {
      this.hideOptions();
    } else if (op === HIDDEN) {
      this.setState({ options: SHOW });
    }
  };

  hideOptions = e => {
    if (this.state.options === SHOW) {
      this.setState({ options: FADE }, () => delay(() => this.setState({ options: HIDDEN })));
    }
  };

  handleClick = e => {
    let id = e.target.id;

    if (!id) {
      id = e.target.parentElement.id;
    }

    if (id !== 'options-button' && !id.startsWith('volume-')) {
      this.hideOptions();
    }
  };

  render() {
    return (
      <div className="page-root">
        <div className="mt-page ta-game-page" style={{ backgroundImage: Background }} onClick={this.handleClick}>
          <Scoreboard board={this.board} ref={this.scoreboard} />
          <Board ref={this.board} toolbar={this.toolbar} scoreboard={this.scoreboard} />
          {this.props.showLeaders === HIDE ? null : <Leaderboard />}
        </div>
        <Options op={this.state.options} hideOptions={this.hideOptions} />
        <Toolbar ref={this.toolbar} board={this.board} onClickOptions={this.handleOptions} hideOptions={this.hideOptions} />
        {this.props.showLeaders === HIDE ? (
          <>
            <BackButton />
            <HomeButton />
          </>
        ) : null}
      </div>
    );
  }
}

function mapStateToProps({ mt, common }) {
  return { ...mt, ...common };
}

export default connect(
  mapStateToProps,
  { updateStats, requestResetStats, requestSurrender, showHelp }
)(GamePage);
